"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.empty = empty;
exports.isIterable = isIterable;
exports.ensureIterable = ensureIterable;
exports.isValidIterableArgument = isValidIterableArgument;
exports.BaseMethodIterable = BaseMethodIterable;
exports.MethodIterable = MethodIterable;
exports.wrapWithMethodIterable = wrapWithMethodIterable;
exports.iterableCurry = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _create = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/create"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _iterator = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _curry = require("./curry");

var _marked = _regenerator["default"].mark(empty);

function empty() {
  return _regenerator["default"].wrap(function empty$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function isIterable(i) {
  return Boolean(i != null && i[_iterator["default"]]);
}

function ensureIterable(i) {
  if (i == null) {
    return empty();
  } else if (!isIterable(i)) {
    if (typeof i.next === 'function') {
      throw new TypeError('Iterators are not supported arguments to iter-tools. It must be an iterable. For example: { [Symbol.iterator] : () => currentArgument }');
    }

    throw new TypeError('The argument is not an iterable or null');
  }

  return i;
}

function isValidIterableArgument(i) {
  return i == null || isIterable(i);
}

function BaseMethodIterable(fn, args, iterablesArg) {
  this._fn = fn;
  this._args = args;
  this._iterablesArg = iterablesArg;
  this._staticIterator = null;
}

(0, _assign["default"])(BaseMethodIterable.prototype, {
  __iterate: function __iterate() {
    return this._fn.apply(this, [this._iterablesArg].concat((0, _toConsumableArray2["default"])(this._args)));
  },
  "throw": function _throw() {
    this._staticIterator = this._staticIterator || this.__iterate();
    return this._staticIterator["throw"]();
  },
  next: function next() {
    this._staticIterator = this._staticIterator || this.__iterate();
    return this._staticIterator.next();
  },
  "return": function _return() {
    if (typeof this._staticIterator["return"] === 'function') {
      var _this$_staticIterator;

      (_this$_staticIterator = this._staticIterator)["return"].apply(_this$_staticIterator, arguments);
    }
  }
});

function MethodIterable() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  BaseMethodIterable.apply(this, args);
}

MethodIterable.prototype = (0, _assign["default"])((0, _create["default"])(BaseMethodIterable.prototype), (0, _defineProperty2["default"])({
  constructor: MethodIterable
}, _iterator["default"], function () {
  return this.__iterate();
}));

function SimpleMethodIterable() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  MethodIterable.apply(this, args);
}

SimpleMethodIterable.prototype = (0, _assign["default"])((0, _create["default"])(MethodIterable.prototype), {
  __iterate: function __iterate() {
    return this._fn.apply(this, (0, _toConsumableArray2["default"])(this._args));
  }
});

function makeFunctionConfig(fn) {
  var fnConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var validateArgs = fnConfig.validateArgs,
      variadic = fnConfig.variadic,
      reduces = fnConfig.reduces,
      optionalArgsAtEnd = fnConfig.optionalArgsAtEnd,
      minArgs = fnConfig.minArgs,
      maxArgs = fnConfig.maxArgs;
  return {
    fn: fn,
    validateArgs: validateArgs || function (_) {},
    variadic: !!variadic,
    reduces: !!reduces,
    optionalArgsAtEnd: !!optionalArgsAtEnd,
    minArgs: minArgs === undefined ? fn.length - 1 : minArgs,
    maxArgs: maxArgs === undefined ? fn.length - 1 : maxArgs,
    isIterable: isValidIterableArgument,
    iterableType: 'iterable',
    applyOnIterableArgs: ensureIterable,
    IterableClass: MethodIterable
  };
}

function wrapWithMethodIterable(fn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$validateArgs = _ref.validateArgs,
      validateArgs = _ref$validateArgs === void 0 ? function (_) {
    return _;
  } : _ref$validateArgs;

  return function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    validateArgs(args);
    return new SimpleMethodIterable(fn, args);
  };
}

var iterableCurry = function iterableCurry(fn, config) {
  return (0, _curry.variadicCurryWithValidation)(makeFunctionConfig(fn, config));
};

exports.iterableCurry = iterableCurry;